'use strict';
var forsyningsservice = forsyningsservice || {};
const siteSearchToggle = document.getElementById('input-toggle__site-search');
const siteSearchInput = document.getElementById('js-site-search-input');
const darkOverlay = document.getElementById('js-dark-overlay');

forsyningsservice.search = forsyningsservice.search || function () {

	function init() {
		siteSearchToggle.addEventListener('click', function() {
    		forsyningsservice.navigation.closeNav();
			siteSearchInput.focus();
		});
		setupCloseSearch();
	}

	function setupCloseSearch() {
		darkOverlay.addEventListener('click', function() {
			closeSearch();
		});
		
		document.addEventListener('keydown', function(event) {
			if(event.key === "Escape"){
				closeSearch();
			}
		});
	}

	function closeSearch() {
		siteSearchToggle.checked = false;
	}

	return {
		init : init,
		closeSearch: closeSearch
	};

}();